export const components = {
    diferencaVariavel: {
        name: "Diferença Variável",
        keys: [
            {name: "data_inicial"},
            {name: "data_final"},
            {name: "total_pago"},
            {name: "total_devido"},
            {name: "diferenca"}, 
        ],
        render: (setForm) => {},
    },
    historicoSalarial: {
        name: "Histórico salarial",
        keys: [
            {name: "data_inicial"},
            {name: "data_final"},
            {name: "total_pago"},
        ],
        render: (setForm) => {},
    },
}

export const findComponentByName = (componentName) => {
    return Object.values(components).find(component => component.name === componentName) || null;
};
